var _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPaymentMethods = function SvgPaymentMethods(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 200 200",
    focusable: false,
    "aria-hidden": true
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "payment_methods_svg2__a",
    x1: 21.43,
    x2: 155.48,
    y1: 186.04,
    y2: 18.29,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#3d43c1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#a80096"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#payment_methods_svg2__a",
    id: "payment_methods_svg2__c",
    x1: 94.03,
    x2: 228.07,
    y1: 244.05,
    y2: 76.3
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#payment_methods_svg2__a",
    id: "payment_methods_svg2__d",
    x1: -43.2,
    x2: 90.84,
    y1: 134.39,
    y2: -33.36
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#payment_methods_svg2__a",
    id: "payment_methods_svg2__e",
    x1: -35.08,
    x2: 98.96,
    y1: 140.88,
    y2: -26.86
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#payment_methods_svg2__a",
    id: "payment_methods_svg2__f",
    x1: -26.95,
    x2: 107.09,
    y1: 147.38,
    y2: -20.37
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#payment_methods_svg2__a",
    id: "payment_methods_svg2__g",
    x1: -1.96,
    x2: 132.09,
    y1: 167.35,
    y2: -0.4
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#payment_methods_svg2__a",
    id: "payment_methods_svg2__h",
    x1: 6.17,
    x2: 140.21,
    y1: 173.84,
    y2: 6.1
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#payment_methods_svg2__a",
    id: "payment_methods_svg2__i",
    x1: 14.3,
    x2: 148.34,
    y1: 180.34,
    y2: 12.59
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#payment_methods_svg2__a",
    id: "payment_methods_svg2__j",
    x1: -18.82,
    x2: 115.22,
    y1: 153.87,
    y2: -13.87
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#payment_methods_svg2__a",
    id: "payment_methods_svg2__k",
    x1: 22.43,
    x2: 156.47,
    y1: 186.83,
    y2: 19.09
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M180.15 103.38h-10v-100c0-1.35-.81-2.56-2.07-3.07a3.325 3.325 0 0 0-3.63.7l-7.63 7.67-7.63-7.67a3.34 3.34 0 0 0-4.37-.3l-11.33 8.5L122.15.72a3.3 3.3 0 0 0-4 0l-11.33 8.5L95.49.72a3.3 3.3 0 0 0-4 0l-11.33 8.5L68.83.72a3.3 3.3 0 0 0-4 0L53.5 9.22 42.16.72a3.3 3.3 0 0 0-4 0l-11.33 8.5L15.5.72a3.33 3.33 0 0 0-3.5-.3 3.26 3.26 0 0 0-1.83 2.97v193.32c-.01 1.26.7 2.42 1.83 2.97 1.13.57 2.48.46 3.5-.3l11.33-8.5 11.33 8.5c1.18.9 2.82.9 4 0l11.33-8.5 11.33 8.5c1.18.9 2.82.9 4 0l11.33-8.5 11.33 8.5c1.18.9 2.82.9 4 0l11.33-8.5 11.33 8.5c1.18.9 2.82.9 4 0l11.33-8.5 11.33 8.5c1.33 1 3.19.88 4.37-.3l7.63-7.67 7.63 7.67c.63.62 1.48.97 2.37.97.44.01.87-.08 1.27-.27 1.25-.5 2.07-1.72 2.07-3.07v-23.33h10a10.03 10.03 0 0 0 10-10v-50a10.03 10.03 0 0 0-10-10Zm-16.67 85.29-4.3-4.33a3.356 3.356 0 0 0-4.73 0l-7.93 7.97-11.03-8.27a3.3 3.3 0 0 0-4 0l-11.33 8.5-11.33-8.5a3.3 3.3 0 0 0-4 0l-11.33 8.5-11.33-8.5a3.3 3.3 0 0 0-4 0l-11.33 8.5-11.33-8.5a3.3 3.3 0 0 0-4 0l-11.33 8.5-11.33-8.5a3.3 3.3 0 0 0-4 0l-8 6V10.05l8 6c1.18.9 2.82.9 4 0l11.33-8.5 11.33 8.5c1.18.9 2.82.9 4 0l11.33-8.5 11.33 8.5c1.18.9 2.82.9 4 0l11.33-8.5 11.33 8.5c1.18.9 2.82.9 4 0l11.33-8.5 11.33 8.5c1.18.9 2.82.9 4 0l11.03-8.27 7.93 7.97c1.31 1.3 3.42 1.3 4.73 0l4.3-4.33v91.96H93.49a10.03 10.03 0 0 0-10 10v50a10.03 10.03 0 0 0 10 10h69.99v15.3Zm20-25.3c0 1.84-1.49 3.33-3.33 3.33H93.49c-1.84 0-3.33-1.49-3.33-3.33v-30h93.33v30Zm0-36.66H90.15v-3.33h93.33zm0-10H90.15v-3.33c0-1.84 1.49-3.33 3.33-3.33h86.66c1.84 0 3.33 1.49 3.33 3.33v3.33Z",
    style: {
      fill: "url(#payment_methods_svg2__a)",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.48 163.37h13.33a8.33 8.33 0 0 0 0-16.66h-13.33a8.33 8.33 0 0 0 0 16.66m0-10h13.33c.92 0 1.67.75 1.67 1.67s-.75 1.67-1.67 1.67h-13.33c-.92 0-1.67-.75-1.67-1.67s.75-1.67 1.67-1.67",
    style: {
      fill: "url(#payment_methods_svg2__c)",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.19 30.05H31.83c-1.84 0-3.33 1.49-3.33 3.33s1.49 3.33 3.33 3.33h11.36c1.84 0 3.33-1.49 3.33-3.33s-1.49-3.33-3.33-3.33",
    style: {
      fill: "url(#payment_methods_svg2__d)",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.19 46.71H31.83c-1.84 0-3.33 1.49-3.33 3.33s1.49 3.33 3.33 3.33h11.36c1.84 0 3.33-1.49 3.33-3.33s-1.49-3.33-3.33-3.33",
    style: {
      fill: "url(#payment_methods_svg2__e)",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.19 63.38H31.83c-1.84 0-3.33 1.49-3.33 3.33s1.49 3.33 3.33 3.33h11.36c1.84 0 3.33-1.49 3.33-3.33s-1.49-3.33-3.33-3.33",
    style: {
      fill: "url(#payment_methods_svg2__f)",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.37 36.71h83.45c1.84 0 3.33-1.49 3.33-3.33s-1.49-3.33-3.33-3.33H63.37c-1.84 0-3.33 1.49-3.33 3.33s1.49 3.33 3.33 3.33",
    style: {
      fill: "url(#payment_methods_svg2__g)",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.37 53.38h83.45c1.84 0 3.33-1.49 3.33-3.33s-1.49-3.33-3.33-3.33H63.37c-1.84 0-3.33 1.49-3.33 3.33s1.49 3.33 3.33 3.33",
    style: {
      fill: "url(#payment_methods_svg2__h)",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.37 70.05h83.45c1.84 0 3.33-1.49 3.33-3.33s-1.49-3.33-3.33-3.33H63.37c-1.84 0-3.33 1.49-3.33 3.33s1.49 3.33 3.33 3.33",
    style: {
      fill: "url(#payment_methods_svg2__i)",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("rect", {
    width: 18.02,
    height: 6.67,
    x: 28.5,
    y: 80.04,
    rx: 3.33,
    ry: 3.33,
    style: {
      fill: "url(#payment_methods_svg2__j)",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("rect", {
    width: 90.12,
    height: 6.67,
    x: 60.04,
    y: 80.04,
    rx: 3.33,
    ry: 3.33,
    style: {
      fill: "url(#payment_methods_svg2__k)",
      strokeWidth: 0
    }
  }));
};
export default SvgPaymentMethods;